module.exports = __webpack_public_path__ + "static/media/005-information.6599b667.svg";